module.exports = __webpack_public_path__ + "img/profile-bg.00463126.jpg";